import moment from 'moment';

const dateTimeFilter = (dateString: string | number | Date, format: string) => {
  const date = moment(dateString);
  return moment(date).format(format);
};

export default dateTimeFilter;
